import React from "react";
import { useSelector } from "react-redux";
import { getRestrictionDisplayMessage } from "../../Utils/syncAccountRestriction";

const RestrictedAccountBanner = () => {
  const { isRestricted, restrictionReason } = useSelector(
    (state) => state.accountRestriction
  );

  if (!isRestricted) {
    return null;
  }

  return (
    <div className="mx-4 mt-3 rounded-lg border-2 border-red-400 bg-red-50 px-4 py-3 text-red-900 shadow-sm">
      <p className="text-sm font-semibold text-red-700">Account Restricted</p>
      <p className="mt-1 text-sm text-red-800">
        {getRestrictionDisplayMessage(restrictionReason)}
      </p>
    </div>
  );
};

export default RestrictedAccountBanner;
